<template>
  <a-modal
      :width="900"
      v-model="visible"
      :confirm-loading="confirmLoading"
      :bodyStyle="{ maxHeight: '700px', overflowY: 'auto' }"
      @cancel="handleCancel"
      @keydown.native.enter="handleBind(true)"
  >
    <template #title>
      <div>批量绑定、打印衣袋信息</div>
      <div style="color: red; ">（仅显示未绑定衣袋，且会员未过期的用户）</div>
    </template>
    <div class="container">
      <div class="left-panel">
        <a-icon type="minus" style="color: blue;"/> 未执行<br>
        <a-icon type="check" style="color: green;"/> 成功<br>
        <a-icon type="close" style="color: red;"/> 失败<br><br>
        本次总计待绑定{{ records.length }}条数据
        <a-tree default-expand-all @select="onSelect" :key="modalKey" >
          <a-tree-node v-for="(record,index) in records" :key="index" :selectedKeys="selectedKeys" >
            <template slot="title">
              <span v-if="selectedKeys[0] === index" style="background-color: dodgerblue">
                {{`${index + 1}、${record.realName}`}}
              </span>
              <span v-else>
                {{`${index + 1}、${record.realName}`}}
              </span>
              （绑 <a-icon v-if="!records[index].input?.bindStatus" type="minus" style="color: blue;"/><a-icon v-else-if="records[index].input?.bindStatus === 1" type="check" style="color: green;"/><a-icon v-else type="close" style="color: red;"/>
              印 <a-icon v-if="!records[index].input?.printStatus" type="minus" style="color: blue;"/><a-icon v-else-if="records[index].input?.printStatus === 1" type="check" style="color: green;"/><a-icon v-else type="close" style="color: red;"/>）
            </template>
          </a-tree-node>
        </a-tree>
      </div>
      <div class="right-panel">
        <a-form :form="form">
          <!-- 新增扫描输入框 -->
          <a-form-item
              label="读卡器输入"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              hasFeedback
          >
            <a-input
                ref="scannerInput"
                v-decorator="['scannerInput', { rules: [{ required: true, message: '请使用读卡器输入!' }] }]"
                placeholder="读入8位标签或14位衣袋"
                @input.native="handleScannerInput"
                @change.native="handleScannerChange"
                @blur="handleScannerBlur"
            />
          </a-form-item>

          <!-- 衣袋号展示字段 -->
          <a-form-item
              label="衣袋号"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
          >
            <span>{{ currentInput.pocketNo || '未设置' }}</span><a-button v-if="currentInput.pocketNo" type="link" @click="handleClear(0)">清除</a-button>
          </a-form-item>

          <!-- 硅胶标签展示字段 -->
          <a-form-item
              label="硅胶标签一"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
          >
            <span>{{ currentInput.labelNo1 || '未设置' }}</span><a-button v-if="currentInput.labelNo1 && currentInput.labelNo1 !== ''" type="link" @click="handleClear(1)">清除</a-button>
          </a-form-item>

          <a-form-item
              label="硅胶标签二"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
          >
            <span>{{ currentInput.labelNo2 || '未设置' }}</span><a-button v-if="currentInput.labelNo2 && currentInput.labelNo2 !== ''" type="link" @click="handleClear(2)">清除</a-button>
          </a-form-item>

          <a-form-item
              label="硅胶标签三"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
          >
            <span>{{ currentInput.labelNo3 || '未设置' }}</span><a-button v-if="currentInput.labelNo3 && currentInput.labelNo3 !== ''" type="link" @click="handleClear(3)">清除</a-button>
          </a-form-item>
          <a-form-item
              label="操作"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
          >
            <a-button type="primary" @click="handleBind(false)" :disabled="!canSubmit" :loading="loading">
              {{currentInput.bindStatus === 1 ? '再次绑定': '仅绑定'}}
            </a-button>
            <a-button type="primary" icon="enter" :loading="loading" :disabled="!canSubmit" @click="handleBind(true)" style="margin-left: 15px">
              {{currentInput.bindStatus === 1 ? '再次绑定并打印': '绑定并打印'}}
            </a-button>
            （回车键）
          </a-form-item>
          <a-divider />
          <a-form-item
              label="当前学生"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
          >
            <span>{{ records[selectedKeys[0]]?.realName }}</span>
          </a-form-item>
          <a-form-item
              label="绑定状态"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
          >
            <span v-if="!currentInput.bindStatus" style="color: red; font-weight: bold">未绑定</span>
            <span v-else-if="currentInput.bindStatus === 1" style="color: green; font-weight: bold">已绑定</span>
            <span v-else style="color: red; font-weight: bold">绑定错误</span>
          </a-form-item>
          <a-form-item
              label="打印状态"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
          >
            <span v-if="currentInput.printStatus && currentInput.printStatus === 1" style="color: green; font-weight: bold">已打印</span>
            <span v-else style="color: red; font-weight: bold">未打印</span>
          </a-form-item>
        </a-form>

      </div>
    </div>
    <template #footer>
      <a-button key="submit" type="primary" :loading="confirmLoading" @click="handleCancel">
        确定
      </a-button>
    </template>
  </a-modal>
</template>

<script>
import userService from '@/service/user.js'
import moment from "moment";

export default {
  data() {
    return {
      labelCol: {
        xs: {span: 24},
        sm: {span: 7}
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 13}
      },
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      formData: {},
      nextLabelIndex: 0,
      inputBuffer: '', // 用于存储输入缓冲区
      records: [],

      selectedKeys: [],
      modalKey: 0,

      loading: false, // 按钮加载中
      currentInput: {
      },
      // 打印数据
      printData: {}
    }
  },
  computed: {
    canSubmit() {
      // 仅当label1/2/3和pocket均非空且不为空字符串时为true
      return this.currentInput.labelNo1 && this.currentInput.labelNo1.trim() !== '' &&
          this.currentInput.labelNo2 && this.currentInput.labelNo2.trim() !== '' &&
          this.currentInput.labelNo3 && this.currentInput.labelNo3.trim() !== '' &&
          this.currentInput.pocketNo && this.currentInput.pocketNo.trim() !== '';
    },
    currentRecord() {
      if (this.records.length === 0) {
        return {}
      }
      return this.records[this.selectedKeys[0]];
    }
  },
  methods: {
    showForm(records) {
      this.records = records
      this.selectedKeys = [0]
      this.modalKey += 1  // 改变key值强制重新渲染
      this.visible = true
      this.handleCurrentInput()

      // 初始化下一个要填充的标签索引
      this.nextLabelIndex = 0
      if (this.currentInput.labelNo1) this.nextLabelIndex = 1
      if (this.currentInput.labelNo2) this.nextLabelIndex = 2
      if (this.currentInput.labelNo3) this.nextLabelIndex = 3

      this.$nextTick(() => {
        // 自动聚焦到扫描输入框
        this.$refs.scannerInput.focus()

        // 清空扫描输入框
        this.form.setFieldsValue({
          scannerInput: ''
        })
      })
    },
    handleCurrentInput() {
      if (!this.records[this.selectedKeys[0]].input) {
        this.records[this.selectedKeys[0]].input = {
          labelNo1: '',
          labelNo2: '',
          labelNo3: '',
          pocketNo: '',
          bindStatus: 0,
          printStatus: 0
        }
      }
      this.currentInput = this.records[this.selectedKeys[0]].input
      if (!this.currentInput.labelNo1) {
        this.nextLabelIndex = 0
      } else if (!this.currentInput.labelNo2) {
        this.nextLabelIndex = 1
      } else if (!this.currentInput.labelNo3) {
        this.nextLabelIndex = 2
      } else {
        this.nextLabelIndex = 0
      }
    },
    onSelect(selectedKeys, e) {
      this.selectedKeys = selectedKeys
      this.handleCurrentInput()
    },

    handleScannerInput(event) {
      // 监听输入事件，适用于大多数读卡器
      const value = event.target.value;
      this.checkAndProcessInput(value);
    },

    handleScannerChange(event) {
      // 监听变化事件，作为备用方案
      const value = event.target.value;
      this.checkAndProcessInput(value);
    },

    handleScannerBlur(event) {
      // 失去焦点时也检查输入，确保不会遗漏
      const value = event.target.value;
      this.checkAndProcessInput(value);
    },
    handleClear(index) {
      if (index === 0) {
        this.currentInput.pocketNo = ''
      }
      if (index === 1) {
        this.currentInput.labelNo1 = ''
        this.nextLabelIndex = 0
      }
      if (index === 2) {
        this.currentInput.labelNo2 = ''
        this.nextLabelIndex = 1
      }
      if (index === 3) {
        this.currentInput.labelNo3 = ''
        this.nextLabelIndex = 2
      }
      this.$message.success('清除成功');
    },

    checkAndProcessInput(value) {
      if (!value) return;

      // 检查是否是8位或14位（不再限定必须是数字）
      if (value.length === 8 || value.length === 14) {
        this.processScannerInput(value);
        // 清空输入框
        this.form.setFieldsValue({
          scannerInput: ''
        });
        this.inputBuffer = '';
      }
      if (value.length > 14) {
        this.$message.error('无效读入：' + value)
        // 清空输入框
        this.form.setFieldsValue({
          scannerInput: ''
        });
        this.inputBuffer = '';
      }
    },
    handleBind(print = false) {
      if (!this.canSubmit) {
        return;
      }
      // 处理标签数据
      const labelNos = [
        this.currentInput.labelNo1,
        this.currentInput.labelNo2,
        this.currentInput.labelNo3
      ].filter(label => label && label.trim() !== '')

      // 构造提交数据
      const submitData = {
        id: this.currentRecord.id,
        pocketNo: this.currentInput.pocketNo,
        labelNos,
        print
      }

      this.loading = true

      userService.editPocketBind(submitData).then(res => {
        this.loading = false
        this.currentInput.bindStatus = 1
        this.currentRecord.labelNos = labelNos
        this.currentRecord.pocketNo = this.currentInput.pocketNo

        this.$message.success('绑定成功')

        if (print) {
          this.$emit("print", this.currentRecord)
          this.currentInput.printStatus = 1
          this.currentRecord.printTime = moment().format("YYYY-MM-DD HH:mm:ss")
        }
      }).catch(err => {
        this.loading = false
        this.currentInput.bindStatus = 2
      })
    },

    processScannerInput(value) {
      value = value.trim();

      // 如果输入8位，则依次填充标签
      if (value.startsWith('00') && value.length === 8) {
        // 检查是否与已绑定的标签相同，如果相同则忽略
        if (value === this.currentInput.labelNo1 || value === this.currentInput.labelNo2 || value === this.currentInput.labelNo3) {
          this.$message.info('忽略：读入重复标签：' + value)
          return;
        }

        // 根据nextLabelIndex决定填充哪个标签
        switch (this.nextLabelIndex) {
          case 0:
            this.$message.success('成功读入标签一：' + value)
            this.currentInput.labelNo1 = value;
            this.nextLabelIndex = 1;
            break;
          case 1:
            this.$message.success('成功读入标签二：' + value)
            this.currentInput.labelNo2 = value;
            this.nextLabelIndex = 2;
            break;
          case 2:
            this.$message.success('成功读入标签三：' + value)
            this.currentInput.labelNo3 = value;
            this.nextLabelIndex = 3;
            break;
          default:
            this.$message.success('成功读入标签一：' + value)
            // 如果三个标签都已填满，重新从第一个开始
            this.currentInput.labelNo1 = value;
            this.nextLabelIndex = 1;
            break;
        }
      }
      // 如果输入14位，则填充衣袋号
      else if (value.length === 14) {
        this.$message.success('成功读入衣袋号：' + value)
        this.currentInput.pocketNo = value;
      } else {
        this.$message.error('读入无效数据：' + value)
      }
    },

    handleCancel() {
      this.visible = false
      this.selectedKeys=[]
      this.records = []
      this.loading = false
    }
  },
}
</script>

<style scoped>.container {
  display: flex;
  flex-direction: row;
}

.left-panel {
  flex: 2;
}

.right-panel {
  flex: 5;
}
</style>